import { Card, CardHeader } from "@/components/ui/Card";
import React from "react";

/**
 * Loading skeleton for job detail.
 *
 * @component
 */
const LoadingSkeleton = () => {
  return (
    <Card className="animate-pulse p-0 border-none">
      {/* Header */}
      <CardHeader className="flex flex-row justify-between items-start mb-6 p-0">
        <div className="w-full">
          <div className="h-6 w-1/3 bg-zinc-700 rounded mb-2"></div>
          <div className="h-4 w-1/4 bg-zinc-700 rounded mb-3"></div>

          <div className="flex gap-3 flex-wrap">
            {[...Array(3)].map((_, i) => (
              <div className="h-6 w-24 bg-zinc-700 rounded-full" key={i} />
            ))}
          </div>
        </div>

        <div className="h-10 w-28 bg-zinc-700 rounded-full"></div>
      </CardHeader>

      {/* Skills */}
      <div className="flex flex-wrap gap-2 mb-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-6 w-20 bg-zinc-700 rounded-md"></div>
        ))}
      </div>

      {/* Role Overview */}
      <div className="mb-8">
        <div className="h-5 w-40 bg-zinc-700 rounded mb-3"></div>
        <div className="space-y-2">
          <div className="h-3 w-full bg-zinc-700 rounded"></div>
          <div className="h-3 w-5/6 bg-zinc-700 rounded"></div>
          <div className="h-3 w-4/6 bg-zinc-700 rounded"></div>
        </div>
      </div>

      {/* Key Responsibilities */}
      <div className="mb-8">
        <div className="h-5 w-48 bg-zinc-700 rounded mb-3"></div>
        <div className="space-y-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex gap-2 items-start">
              <div className="w-2 h-2 bg-zinc-700 rounded-full mt-1.5"></div>
              <div className="h-3 w-full bg-zinc-700 rounded"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Cards */}
      <div className="flex gap-4 mb-8">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex-1 p-4 rounded-xl bg-zinc-800">
            <div className="h-4 w-32 bg-zinc-700 rounded mb-3"></div>
            <div className="space-y-2">
              <div className="h-3 w-full bg-zinc-700 rounded"></div>
              <div className="h-3 w-5/6 bg-zinc-700 rounded"></div>
              <div className="h-3 w-4/6 bg-zinc-700 rounded"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Company Section */}
      <div className="-mx-8">
        <div className="border-t border-border-primary"></div>

        <div className="px-8 pt-6">
          <div className="h-4 w-24 bg-zinc-700 rounded mb-4"></div>

          <div className="flex gap-3">
            <div className="h-10 w-40 bg-zinc-700 rounded-md"></div>
            <div className="h-10 w-40 bg-zinc-700 rounded-md"></div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default LoadingSkeleton;
